import React from 'react';
import PropTypes from 'prop-types';
import decl from '~h/decl';
import fakeFetch from '~/data/fakeFetch';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import {sentUsersBrowserData} from '../../../pages/EventReg/utils'
import PopupClose from '../Close';

class SmsVerification extends React.Component {
  smsMaxtimeoutMS = 60000;

  smsTimeoutTickInterval = null;

  state = {
    smsTimeoutMS: this.smsMaxtimeoutMS,
    smsLastSend: Date.now(),
    errorMessage: '',
    isCanRequestSms: false,
    code: '',
    spinnerState: spinnerStates.done,
  };

  componentDidMount() {
    this.requestSms();
  }

  componentWillUnmount() {
    clearInterval(this.smsTimeoutTickInterval);
  }

  startTimer = () => {
    clearInterval(this.smsTimeoutTickInterval);
    this.smsTimeoutTickInterval = setInterval(() => {
      const elapsed = Date.now() - this.state.smsLastSend;
      let currentTimeoutMS = this.smsMaxtimeoutMS - elapsed;
      if (currentTimeoutMS <= 0) {
        currentTimeoutMS = 0;
      }

      this.setState({ smsTimeoutMS: currentTimeoutMS });
      if (currentTimeoutMS <= 0) {
        this.setState({ isCanRequestSms: true });
        clearInterval(this.smsTimeoutTickInterval);
      }
    }, 1000);
  };

  requestSms = () => {
    this.setState({
      smsTimeoutMS: this.smsMaxtimeoutMS,
      isCanRequestSms: false,
      smsLastSend: Date.now(),
    });
    this.startTimer();

    // FIXME: delete fake fetch
    // const trueFetch = fetch;
    // fetch = fakeFetch({
    //   status: 'error',
    //   data: [],
    //   errors: [
    //     {
    //       message:
    //         'сообщение об ошибке',
    //       code: 'ERR_TIMEOUT',
    //       customData: { NEXT_SMS: 27 },
    //     },
    //   ],
    // }, 1000);

    // FIXE: hardcoded cookies
    // const cookie =
    //   'PHPSESSID=1gr24tki39tevsiul0462eb8g0; BITRIX_SM_LOGIN=admin; BITRIX_SM_SOUND_LOGIN_PLAYED=Y';

    const options = {
      method: 'POST',
      headers: {
        // cookie,
        'content-type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        LOGIN: this.props.phone,
      }),
    };

    this.setState({ errorMessage: '' });
    fetch(routes.user.code, options)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'error') {
          const timeOut = json.errors.find(
            error => error.code === 'ERR_TIMEOUT',
          ).customData?.NEXT_SMS;

          if (timeOut) {
            const smsLastSend = Date.now() - timeOut * 1000;
            this.setState({ smsLastSend });
          }

          this.setState({ errorMessage: json.errors[0].message });
        }
      })
      .catch(() => {
        this.setState({ errorMessage: messages.serverTimeout });
      });

    // fetch = trueFetch;
  };

  verifyViaSms = e => {
    e.preventDefault();

    // FIXE: hardcoded cookies
    // const cookie =
    //   'PHPSESSID=b17dc358ee6b8b61d0008c16f90b450d; BITRIX_SM_LOGIN=admin; BITRIX_SM_SOUND_LOGIN_PLAYED=Y; BITRIX_SM_UIDH=7dacf9c27454a0928642b750d1b6e37c; BITRIX_SM_UIDL=%252B79991714746';

    const options = {
      method: 'POST',
      headers: {
        // cookie,
        'content-type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        LOGIN: this.props.phone,
        CODE: this.state.code,
      }),
    };

    // const trueFetch = fetch;
    // fetch = fakeFetch({
    //   status: 'success',
    // });

    this.setState({ errorMessage: '', spinnerState: spinnerStates.pending });
    fetch(routes.user.verify, options)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.status === 'success') {
          this.props.onVerifyCallback();
          sentUsersBrowserData({data: this.props.user, isNewsSubscribe: this.props.isNewsSubscribe, isPolicyAgreed: true});
          this.setState({
            spinnerState: spinnerStates.done,
          });
          if (this.props.onVerifyLocation !== '') {
            window.location.replace(this.props.onVerifyLocation);
          }
        } else if (json.status === 'error') {
          // TODO: panic!
          this.setState({
            errorMessage: json.errors[0].message,
            spinnerState: spinnerStates.done,
          });
        } else {
          // TODO: panic alot!
          this.setState({
            errorMessage: messages.unknownError,
            spinnerState: spinnerStates.done,
          });
        }
      })
      .catch(() => {
        this.setState({
          errorMessage: messages.serverTimeout,
          spinnerState: spinnerStates.done,
        });
      });

    // fetch = trueFetch;
  };

  render() {
    const timoutSec = Math.round(this.state.smsTimeoutMS / 1000.0);

    return (
      <React.Fragment>
        <div className="popup auth">
          <div className="popup__close-container close_auth"><PopupClose/></div>
          <p className="heading heading--2">Подтверждение телефона</p>
          <form className="auth__form" action="">
            <label className="inp" htmlFor="smsCode">
              <input
                className="inp__field"
                id="smsCode"
                type="text"
                placeholder=" "
                autoComplete="off"
                value={this.state.code}
                onChange={e => this.setState({ code: e.target.value })}
              />
              <p className="inp__label">Введите код из СМС</p>
            </label>

            <button
              type="submit"
              className="btn btn--primary"
              onClick={this.verifyViaSms}
            >
              {this.state.spinnerState === spinnerStates.done ? (
                'Далее'
              ) : (
                <React.Fragment>
                  <div className="invisible">Далее</div>
                  <Loader
                    spinnerState={this.state.spinnerState}
                    spinnerPosition={spinnerPositions.absolute}
                    className="loader--white"
                  />
                </React.Fragment>
              )}
            </button>
            {this.state.errorMessage !== '' ? (
              <div className="error error__unique error__unique--left0 error__unique--top20 error--center error--red">
                {this.state.errorMessage}
              </div>
            ) : null}
          </form>

          {this.state.isCanRequestSms ? (
            <button
              type="button"
              onClick={this.requestSms}
              className="requestMessage"
            >
              <div className="requestMessage--center txt--red">
                Отправить смс еще раз
              </div>
            </button>
          ) : (
            <div className="requestMessage requestMessage--center">
              <div className="requestMessage--center requestMessage--noBottomMargin">
                Повторно код можно отправить
              </div>

              <div className="requestMessage--center">
                через {timoutSec}{' '}
                {decl(timoutSec, ['секунду', 'секунды', 'секунд'])}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

SmsVerification.propTypes = {
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onVerifyCallback: PropTypes.func,
  onVerifyLocation: PropTypes.string,
};

SmsVerification.defaultProps = {
  onVerifyCallback: () => {},
  onVerifyLocation: '/registration/set-password',
};

export default SmsVerification;
